import { NonIdealState } from "@blueprintjs/core";
import React from "react";

import { usePlaybookContext } from "../../playbook-context";
import { PlaybookCard } from "../playbook-card/playbook-card";
import styles from "./playbook-viewer.module.scss";

export const PlaybookViewer = () => {
  const { selectedPlaybook: playbook } = usePlaybookContext();

  if (!playbook) {
    return (
      <div className={styles.playbookViewer}>
        <NoPlaybookSelected />
      </div>
    );
  }

  return (
    <div className={styles.playbookViewer}>
      <PlaybookCard />
    </div>
  );
};

const NoPlaybookSelected = () => {
  return (
    <NonIdealState
      icon={"manual"}
      title={"No Playbook Selected"}
      description={"Select a Playbook from the list to view it."}
      layout={"vertical"}
    />
  );
};
